import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'

import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

export const savActivityHistoryQueryKey = (network: string, vaultId: string, walletAddress?: string) =>
  ['sav-activity-history', network, vaultId, walletAddress] as const

export const useSAVActivityHistory = (vaultId: string) => {
  const walletAddress = useCurrentWalletAddress()
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    queryKey: savActivityHistoryQueryKey(network, vaultId, walletAddress),
    enabled: !!walletAddress,
    queryFn: async () => {
      if (!walletAddress) {
        throw new Error('Wallet address not defined')
      }
      return await backendClient.getSavActivityHistoryForWallet(walletAddress, vaultId)
    },
    refetchInterval: 30 * 1000,
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data,
    refetch: result.refetch,
  }
}
